<template>
  <div class="wt2-carousel-gallery">
    <transition name="wt2-fade">
      <div
        class="-arrow -arrow-left"
        @click="$_onArrowLeft"
        v-show="hasArrowLeft"
      >
        <i class="wticon wticon-angle-left"></i>
      </div>
    </transition>

    <wt-record-mouse-move @change="onMouseMove">
      <wt-scrollable-horizontal
        ref="scrollable"
        :showArrowsIfScrollable="customNavigation"
        :has-left.sync="hasArrowLeft"
        :has-right.sync="hasArrowRight"
        :bus="bus"
      >
        <slot></slot>
      </wt-scrollable-horizontal>
    </wt-record-mouse-move>

    <transition name="wt2-fade">
      <div
        class="-arrow -arrow-right"
        @click="$_onArrowRight"
        v-show="hasArrowRight"
      >
        <i class="wticon wticon-angle-right"></i>
      </div>
    </transition>
  </div>
</template>
<script>
import _ from 'lodash-extended';

export default {
  props: {
    bus: { type: Object, default: () => ({}) },
    customNavigation: { type: Boolean, required: false, default: false },
    offsetLeft: { type: Number, default: 0 },
  },

  data() {
    return {
      hasArrowLeft: false,
      hasArrowRight: false,
    };
  },

  created() {
    this.onEvent(
      'CAROUSEL_GALLERY_RESET',
      this.emitEvent.bind(this, 'SCROLLABLE_HORIZONTAL_RESET')
    );
  },

  watch: {
    offsetLeft: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.emitEvent('SCROLLABLE_HORIZONTAL_SCROLL_TO', newVal);
        }
      },
    },
  },

  methods: {
    $_onArrowLeft() {
      if (this.customNavigation) {
        this.emitEvent('SCENE_ARROW_NAVIGATE_LEFT');
      } else {
        this.emitEvent('SCROLLABLE_HORIZONTAL_OFFSET_LEFT');
      }
    },

    $_onArrowRight() {
      if (this.customNavigation) {
        this.emitEvent('SCENE_ARROW_NAVIGATE_RIGHT');
      } else {
        this.emitEvent('SCROLLABLE_HORIZONTAL_OFFSET_RIGHT');
      }
    },

    onMouseMove(data) {
      // if one of the data props is null or empty, no calculate!
      if (!data.movementX || _.isNull(data.diffX)) {
        return;
      }

      const scrollable = this.$refs.scrollable;
      const scrollableEl = scrollable && scrollable.$el;

      // get the exact point of the mouse and scroll to it
      const scrollTo =
        data.movementX < 0
          ? scrollableEl.scrollLeft + data.diffX
          : scrollableEl.scrollLeft - data.diffX;

      this.emitEvent('SCROLLABLE_HORIZONTAL_SCROLL_TO', scrollTo);
    },

    onEvent(eventName, callback) {
      _.isObject(this.bus) &&
        _.isFunction(this.bus.$on) &&
        this.bus.$on(eventName, callback);
    },

    emitEvent(eventName, data) {
      _.isObject(this.bus) &&
        _.isFunction(this.bus.$emit) &&
        this.bus.$emit(eventName, data);
    },
  },
};
</script>

<style lang="scss" scoped></style>
